import script from "./ForceMajeurs.vue?vue&type=script&setup=true&lang=js"
export * from "./ForceMajeurs.vue?vue&type=script&setup=true&lang=js"

export default script